const BASE_URL = "https://api.heshamalicollection.pk";
//const BASE_URL = "http://localhost:4001";

export default BASE_URL;